import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { QuotationAttachments, QuotationAttachmentsResponse } from '@interfaces';
import { QuotationService } from 'app/main/quotations/services/quotation.service';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import english from '../../../i18n/en.json';
import spanish from '../../../i18n/es.json';
import portuguese from '../../../i18n/pt.json';

@Component({
  selector: 'tab-quotation-attachments',
  styleUrls: ['./tab-quotation-attachments.component.scss'],
  templateUrl: './tab-quotation-attachments.component.html'
})
export class TabQuotationAttachmentsComponent implements OnInit {
  @Input() quotationId: string;
  quotationAttachments: QuotationAttachmentsResponse;
  private readonly reload = new Subject<void>();
  private readonly removeSubscriptions = new Subject<void>();
  public isLoading = true;

  constructor(
    private quotationService: QuotationService,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
  ) {this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish }); }

  public ngOnInit(): void {
    this.reload
      .pipe(
        takeUntil(this.removeSubscriptions),
        tap(() => (this.isLoading = true)),
        switchMap(() => this.getQuotationsAttachments()),
        tap(() => {
          this.isLoading = false;
        })
      )
      .subscribe((page) => {});

    this.reload.next();
  }

  async getQuotationsAttachments(): Promise<void> {
    const quotationAttachments = await this.quotationService.getAttachments(this.quotationId);
    this.quotationAttachments = {
      attachments: quotationAttachments.attachments
        .filter((attachment) => attachment.archived === false)
        .map((attachment) => ({
          ...attachment,
          isImage: this.isAttachmentTypeImage(attachment)
        }))
    };
  }

  isAttachmentTypeImage(attachment: QuotationAttachments): boolean {
    if (attachment.type.indexOf('image/') >= 0 || attachment.type.indexOf('signature') >= 0) {
      return true;
    }
    return false;
  }

  getIconByAttachmentType(attachmentType: string): string {
    if (attachmentType === 'application/pdf') {
      return 'icon-file-pdf';
    }

    if (attachmentType === 'application/msword') {
      return 'icon-file-word';
    }

    if (attachmentType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      return 'icon-file-word';
    }

    if (attachmentType === 'application/vnd.ms-excel') {
      return 'icon-file-excel';
    }

    if (attachmentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      return 'icon-file-excel';
    }

    if (attachmentType === 'application/vnd.ms-powerpoint') {
      return 'icon-file-powerpoint';
    }

    if (attachmentType === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
      return 'icon-file-powerpoint';
    }

    if (attachmentType === 'text/plain') {
      return 'icon-file-document';
    }

    if (attachmentType === 'text/csv') {
      return 'icon-file-delimited';
    }

    if (attachmentType === 'application/vnd.google-earth.kml+xml') {
      return 'icon-google-maps';
    }

    if (attachmentType.includes('video')) {
      return 'icon-file-video';
    }

    return 'icon-file';
  }
}
